import { util } from 'echarts/core';
import { type ThemeParser } from '../../../core/theme';
import { overrideIfUndefined } from '../../../util/data';
import { fontColor, FONT_SIZE_LIST, LINE_HEIGHT_LIST, THS_FONTFAMILY_MEDIUM } from '../static/font';

function parseToolTip(option: Parameters<ThemeParser>[0]) {
  const tooltip = {
    show: true,
    position(
      pos: [number, number],
      params,
      dom: HTMLElement,
      rect,
      size: { contentSize: [number, number]; viewSize: [number, number] }
    ) {
      const grid = option.grid[0];
      const top = grid.top;
      let left, right;
      if (pos[0] < size.viewSize[0] / 2) {
        right = grid.right;
      } else {
        left = grid.left;
      }
      return { top, left, right };
    },
    backgroundColor: 'rgba(59,59,59,1)',
    borderColor: 'rgba(59,59,59,1)',
    textStyle: {
      color: fontColor(1, 'dark'),
      fontSize: FONT_SIZE_LIST.tooltipLabel,
      fontFamily: THS_FONTFAMILY_MEDIUM,
      lineHeight: LINE_HEIGHT_LIST.tooltipLabel
    },
    // 设置toolptip渲染形式为富文本，即在图表内部 ，层级与图表DOM一致。
    // 默认的渲染形式是在页面添加DOM，但是这样这个DOM的默认层级不可控，有业务方反应这个问题。
    // renderMode: 'richText',
    transitionDuration: 0,
    extraCssText: 'box-shadow: 0 0 0 rgba(0, 0, 0, 0); border-radius: 4px; z-index: 1',
    /** echarts默认配置为'item'。
     * 在option.animation = true 的情况下，trigger: 'item'会导致xAxis.axisPointer在mousemove时不能紧跟鼠标。
     * 感觉应该是trigger: 'item'的交互是在鼠标停留在相对稳定的状态下触发axisPointer，有延迟; 'axis'则是鼠标每移动到一个x坐标位置，就触发交互。
     * 在不设置tooltip时，不会有xAxis.axisPointer交互跟不上鼠标的情况
     * */
    trigger: 'axis',
    axisPointer: {
      animation: false
    }
  };
  option.tooltip = util.merge(tooltip, option.tooltip, true);
}

/**
 * 交互
 */
export function parseTooltipInteract(option: Parameters<ThemeParser>[0]) {
  const interactOption = {
    hideDelay: 2e3,
    // @ts-ignore
    dvAutoHide: option.tooltip?.alwaysShowContent !== true
  };

  option.tooltip = util.merge(interactOption, option.tooltip, true);
}

export function ToolTipThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  const chart = args[1];
  // echarts没有到处value类型的坐标轴配置对象， 只能暂时用YAxisComponentOption替代一下

  option.tooltip = overrideIfUndefined(option.tooltip, {});

  parseToolTip(option, chart);
  parseTooltipInteract(option);
}
